import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import {editComment, updateComment, moderateComment} from '../modules/Question-Comments';
import commentFormCreator from './CommentForm';
import {emitEvent} from '../lib/mz';
import UserComment from './components/UserComment';
import PostControls from './components/PostControls';
// import User from './User';

@connect(
  (state) => ({
    widget: state.environment.widget,
    widgetType: state.environment.widgetType,
  }),
  {editComment, updateComment, moderateComment}
)

// eslint-disable-next-line react/prefer-stateless-function
export default class CommentRow extends Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    answer: PropTypes.object,
    comment: PropTypes.object.isRequired,
    user: PropTypes.object,
    updateComment: PropTypes.func.isRequired,
    editComment: PropTypes.func.isRequired,
    moderateComment: PropTypes.func.isRequired,
    widget: PropTypes.bool.isRequired,
    widgetType: PropTypes.string.isRequired,
  };

  render() {
    const {question, answer, comment, user, widgetType} = this.props;

    const parentType = answer ? 'answer' : 'question';
    const parentId = answer ? answer.id : question.id;
    const questionDLM = question.deleted || question.moderated || question.locked;
    const answerDM = (answer && answer.deleted) || (answer && answer.moderated);
    const commentM = comment.moderated;
    const disableEdit = questionDLM || answerDM || commentM;
    const isUsersComment = user && comment.user_id === user.id;
    const userIsModerator = user && user.canModerate;
    const canEdit = isUsersComment || userIsModerator;
    const isEditingComment = Boolean(comment.editing);

    const mzClick = (eventTitle) =>
      emitEvent('CLICK', {eventTitle, id: comment.id, module: {type: widgetType}});

    const onEditClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('comment-edit');
      this.props.editComment(parentType, parentId, comment.id, true);
    };

    const onDeleteClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('comment-delete');
      this.props.updateComment(parentType, {id: comment.id, deleted: true});
    };

    const onUndoDeleteClick = (e) => {
      e.preventDefault();
      if (!canEdit) return;
      mzClick('comment-delete-undo');
      this.props.updateComment(parentType, {id: comment.id, deleted: false});
    };

    const onModerateClick = (e) => {
      e.preventDefault();
      mzClick('comment-moderate');
      this.props.moderateComment(parentType, {id: comment.id, moderated: true});
    };

    const onUndoModerateClick = (e) => {
      e.preventDefault();
      mzClick('comment-moderate-undo');
      this.props.moderateComment(parentType, {id: comment.id, moderated: false});
    };

    const onCloseCommentClick = (e) => {
      e.preventDefault();
      mzClick('comment-close');
      this.props.editComment(parentType, parentId, comment.id, false);
    };

    const commentTextStyle = comment.deleted ? {textDecoration: 'line-through'} : null;
    const moderatedFlag = comment.moderated ? ' [moderated] ' : null;

    const editCommentButton = canEdit && !disableEdit && !comment.deleted ? (
      <a href="" className="t-comment-edit-btn link link--colored" onClick={onEditClick}>
        Edit
      </a>
    ) : null;

    const deleteCommentButton = canEdit && !disableEdit && !comment.deleted ? (
      <a href="" className="t-comment-delete-btn link link--colored" onClick={onDeleteClick}>
        Remove
      </a>
    ) : null;

    const undeleteCommentButton = canEdit && !disableEdit && comment.deleted ? (
      <a href="" className="t-comment-undelete-btn link link--colored" onClick={onUndoDeleteClick}>
        Undo Remove
      </a>
    ) : null;

    const moderateCommentButton = userIsModerator && !comment.moderated ? (
      <a href="" className="t-comment-moderate-btn link link--colored" onClick={onModerateClick}>
        Moderate
      </a>
    ) : null;

    const undoModerateCommentButton = userIsModerator && comment.moderated ? (
      <a href="" className="t-comment-unmoderate-btn link link--colored" onClick={onUndoModerateClick}>
        Un-moderate
      </a>
    ) : null;

    const CommentForm = isEditingComment ? commentFormCreator(`comment-${comment.id}`) : null;
    const commentComponent = isEditingComment ? (
      <div className="comment-list__form">
        <UserComment userId={user.id} username={user.username} when={user.createdHuman} showText={false}>
          <CommentForm comment={comment} question={question} answer={answer} onCloseCommentClick={onCloseCommentClick} />
        </UserComment>
      </div>
    ) : (
      <div className={`t-${parentType}-comment-row comment-list__item`}>
        <UserComment userId={comment.user_id} username={comment.username} when={comment.createdHuman}>
          <div className="post-content" style={commentTextStyle}>{comment.comment}</div>

          <PostControls displayInline>
            {editCommentButton}
            {deleteCommentButton}
            {undeleteCommentButton}
            {moderatedFlag}
            {moderateCommentButton}
            {undoModerateCommentButton}
          </PostControls>
        </UserComment>
      </div>
    );

    return commentComponent;
  }
}
